import { TransformsList } from 'cio/utils/analytics/transforms';
import { IdentityProvider } from 'cio/models/sso-configuration';

const Transforms: TransformsList = {
  ssoIdentityProvider(data: { identityProvider: IdentityProvider }) {
    let eventIdentityProviderLabel = {
      [IdentityProvider.GoogleOIDC]: 'Google OpenID Connect',
      [IdentityProvider.OktaOIDC]: 'Okta OpenID Connect',
      [IdentityProvider.AzureOIDC]: 'Azure OpenID Connect',
      [IdentityProvider.GenericOIDC]: 'Generic OpenID Connect',
    }[data.identityProvider];

    return {
      'Identity Provider': eventIdentityProviderLabel,
    };
  },

  canceledStateViewed(data: { canReactivate: boolean }) {
    return {
      'Reactivate Option Shown': data.canReactivate,
    };
  },

  introModal(data) {
    return {
      'Intro Modal': data.source,
    };
  },
};

export default Transforms;
